import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  addAttachment,
  attachmentDefaultState,
  AttachmentState,
  removeAttachment,
  replaceAttachment,
} from './common/FileUploadReducers';
import {
  addFileToUploadTracker,
  fileUploadStatusDefaultState,
  FileUploadStatusState,
  removeFileFromUploadTracker,
  setFileToError,
  setFileToUploadComplete,
} from './common/FileUploadStatusReducers';

export interface ReferralInfo {
  [attribute: string]: string;
}
export interface ReferralInfoItem {
  attribute: string;
  value: string;
}
export interface CreateCaseState
  extends AttachmentState,
    FileUploadStatusState {
  referralInformation: ReferralInfo;
  requestForm: any;
  attachmentValidationError: string | null;
}

const initialState: CreateCaseState = {
  referralInformation: {},
  requestForm: {},
  attachmentValidationError: null,
  ...attachmentDefaultState,
  ...fileUploadStatusDefaultState,
};

export const createCaseSlice = createSlice({
  name: 'createCase',
  initialState,
  reducers: {
    reset: () => initialState,
    addAttachment,
    removeAttachment,
    replaceAttachment,

    addFileToUploadTracker,
    setFileToUploadComplete,
    removeFileFromUploadTracker,
    setFileToError,

    addReferralInformation: (state, actions) => {
      state.referralInformation = actions.payload;
    },

    addReferralInformationItem: (
      state,
      actions: PayloadAction<ReferralInfoItem>,
    ) => {
      state.referralInformation = {
        ...state.referralInformation,
        [actions.payload.attribute]: actions.payload.value,
      };
    },

    addRequestForm: (state, actions) => {
      state.requestForm = actions.payload;
    },

    setAttachmentValidationError: (state, actions: PayloadAction<string>) => {
      state.attachmentValidationError = actions.payload;
    },

    clearAttachmentValidationError: (state) => {
      state.attachmentValidationError = null;
    },
  },
});

export const {
  addReferralInformation,
  addReferralInformationItem,
  addRequestForm,
  setAttachmentValidationError,
  clearAttachmentValidationError,
  reset,
} = createCaseSlice.actions;
export default createCaseSlice.reducer;
